import { memo } from 'react';
import { Stack, Typography } from '@mui/material';
import { formatearNumeroConComas } from 'views/Components/Shared/utils/formatNumbers';

const ArrowDown = () => (
	<svg
		width="11"
		height="10"
		viewBox="0 0 11 10"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M8.45835 5.0013L7.87085 4.4138L5.54169 6.7388V1.66797H4.70835V6.7388L2.38335 4.40964L1.79169 5.0013L5.12502 8.33464L8.45835 5.0013Z"
			fill="#D32F2F"
		/>
	</svg>
);

const ArrowUp = () => (
	<svg
		width="8"
		height="8"
		viewBox="0 0 8 8"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0.541687 4.0013L1.12919 4.5888L3.45835 2.2638V7.33464H4.29169V2.2638L6.61669 4.59297L7.20835 4.0013L3.87502 0.667969L0.541687 4.0013Z"
			fill="#2E7D32"
		/>
	</svg>
);

const MonthDataField = memo(({ data }) => {
	return (
		<Stack
			spacing="4px"
			sx={{
				pt: '4px',
			}}
		>
			<Stack direction="row" spacing="2px" alignItems="center">
				<Typography
					sx={{
						color:
							!data?.has_changed ||
							!data?.past_values ||
							data?.pvp === data?.past_values?.pvp
								? 'black'
								: data?.pvp > data?.past_values?.pvp
								? '#2E7D32'
								: '#D32F2F',
						fontSize: '10px',
						fontWeight: '400',
						fontFamily: 'Roboto',
					}}
				>
					${formatearNumeroConComas(Math.floor(data?.pvp * 10) / 10)}
				</Typography>

				{!data?.has_changed ||
				!data?.past_values ||
				data?.pvp === data?.past_values?.pvp ? null : data?.pvp >
				  data?.past_values?.pvp ? (
					<ArrowUp />
				) : (
					<ArrowDown />
				)}
			</Stack>

			<Stack direction="row" spacing="2px" alignItems="center">
				<Typography
					sx={{
						color:
							!data?.has_changed ||
							!data?.past_values ||
							data?.tsu === data?.past_values?.tsu
								? 'black'
								: data?.tsu > data?.past_values?.tsu
								? '#2E7D32'
								: '#D32F2F',
						fontSize: '10px',
						fontWeight: '400',
						fontFamily: 'Roboto',
					}}
				>
					{formatearNumeroConComas(data?.tsu)}
				</Typography>

				{!data?.has_changed ||
				!data?.past_values ||
				data?.tsu === data?.past_values?.tsu ? null : data?.tsu >
				  data?.past_values?.tsu ? (
					<ArrowUp />
				) : (
					<ArrowDown />
				)}
			</Stack>

			<Stack direction="row" spacing="2px" alignItems="center">
				<Typography
					sx={{
						color:
							!data?.has_changed ||
							!data?.past_values ||
							data?.mg === data?.past_values?.mg
								? 'black'
								: data?.mg > data?.past_values?.mg
								? '#2E7D32'
								: '#D32F2F',
						fontSize: '10px',
						fontWeight: '400',
						fontFamily: 'Roboto',
					}}
				>
					{formatearNumeroConComas(Math.floor(data?.mg * 10) / 10)}%
				</Typography>

				{!data?.has_changed ||
				!data?.past_values ||
				data?.mg === data?.past_values?.mg ? null : data?.mg >
				  data?.past_values?.mg ? (
					<ArrowUp />
				) : (
					<ArrowDown />
				)}
			</Stack>
		</Stack>
	);
});

export default MonthDataField;
